import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { ITongHopNamRequest } from "../../../model/request/tong-hop-diem/ITongHopNamRequest";
import { ITongHopDiemResponse } from "../../../model/response/tong-hop-diem/ITongHopDiemResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTongHopNamActionsObj = {
    LOAD_START: {} as ITongHopNamRequest,
    LOAD_SUCCESS: {} as ITongHopDiemResponse,
    LOAD_ERROR: "",

    CHANGED_FOCUSED_VALUE_LOP: {} as ITreeviewLopFocusedValue,
}

export const eTongHopNamActionIds = generateActionTypeIds(eTongHopNamActionsObj, "TONG_HOP_NAM");
export type ITongHopNamActionTypes = IGenericActionType<typeof eTongHopNamActionsObj, "TONG_HOP_NAM">;